import Table from '../../images/aulasmarco.png';

export function Schedule() {
    return (
        <div className='card' id='schedule'> 
            <h2>Horários</h2>
            <section className="schedule">
                <img className='days' src={Table} alt="Horários da República do Boxe, de segunda a sexta às sete da manhã e oito da noite. Terças e quintas às sete da noite. Segunda, quarta e sexta às oito da manhã." />
            </section>
        </div>
        
    );
}